import NavigationMenu from './components/NavigationMenu.vue'
import NavigationMenuItem from './components/NavigationMenuItem.vue'
import FilterArea from './components/FilterArea.vue'
import ActionBar from './components/ActionBar.vue'
import PageLayout from './components/PageLayout.vue'

// 引入样式
import './styles/index.scss'

// 导出组件
export {
  NavigationMenu,
  NavigationMenuItem,
  FilterArea,
  ActionBar,
  PageLayout
}

// 作为Vue插件安装
export default {
  install(Vue) {
    Vue.component('NavigationMenu', NavigationMenu)
    Vue.component('NavigationMenuItem', NavigationMenuItem)
    Vue.component('FilterArea', FilterArea)
    Vue.component('ActionBar', ActionBar)
    Vue.component('PageLayout', PageLayout)
  }
}



